import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import moment from 'moment';
import { OrderFieldConfig } from 'src/app/core/classes/orderFieldConfig';
import { DynamicForm } from '../../error-messages';
import { DynamicFormServiceService } from '../../services/dynamic-form-service.service';
import { Constants } from '../../constants';
import { FileDetector } from 'protractor';
import { PropertyName } from 'src/app/core/enumerations/sectionNames';

@Component({
    selector: 'app-order-datepicker-form',
    templateUrl: './order-datepicker-form.component.html',
    standalone: false
})
export class OrderDatepickerFormComponent implements OnInit {
  
constructor(private dynamicService: DynamicFormServiceService) { }
 field: OrderFieldConfig;
 group: UntypedFormGroup;
 isRequired: boolean;
 currentMax = ['USDATE', 'BPDATE', 'MDOB'];
 currentDate = new Date();
 maxdate: Date;
 minDate: Date;
 required = Constants.IS_REQUIRED;
 placeholderValue: string;
 ValidationMessages = {
   invalidDateFormat : DynamicForm.INVALID_DATE_FORMAT,
   dateValidation : DynamicForm.ENTER_VALID,
   minDobDateValidation: DynamicForm.MIN_DOB_DATE_VALIDATION,
 };

 ngOnInit() {
  if (this.currentMax.indexOf(this.field.labelCode) > -1) {
    this.maxdate = this.currentDate;
  } else if (this.field.labelCode === 'EDD') {
    this.minDate = this.currentDate;
    this.maxdate = moment(this.currentDate).add(1 , 'years').toDate();
  }
  else if (this.field.labelCode === PropertyName.DOB) {
    this.minDate = Constants.PATIENT_DOB_MIN_DATE;
  }
  this.isRequired = this.dynamicService.checkHasRequired(this.field);
  this.placeholderValue = this.field.labelName + ' (MM/DD/YYYY)';
 }

 onClosed() {
  this.group.controls[this.field.labelCode].markAsTouched();
}
}
